import { FinanceValueObjectsComplianceExtraFieldOrganizationEnum } from 'generated/resources/datatable.graphql'
import {
  ContactFragment,
  FinanceValueObjectsFinancialDocumentTypeEnum,
  FinancialProjectForSelectFragment,
  LegalEntityForSelectFragment,
  SaleInvoiceComplianceExtraFieldsFieldFragment,
  SalesDocumentTemplateForSelectFragment,
  SubprojectForSelectFragment,
  TaxRateForSelectFragment,
} from 'generated/resources/graphql'

import { BaseSerialSequenceFragment } from 'modules/finance/components/SerialSequences/Selector/types'

export interface LineItem {
  id: string | number | null
  description?: string
  quantity: number | null
  amount: number | null
  taxRate?: TaxRateForSelectFragment | null
}

export interface FormComplianceExtraFields {
  id?: number | null
  countryCode: string
  organization: FinanceValueObjectsComplianceExtraFieldOrganizationEnum
  fields: FieldComplianceExtraField[]
}

export type FieldComplianceExtraField = SaleInvoiceComplianceExtraFieldsFieldFragment & {
  mandatoryForCreditNote?: boolean
  mandatoryForStandardInvoice?: boolean
}

export const defaultLineItem: LineItem = {
  id: '',
  description: undefined,
  quantity: 1,
  amount: null,
  taxRate: null,
}

type SaleInvoiceAction = 'issuing' | 'saving'

export interface SaleInvoiceFormFields {
  currency?: string
  documentNumber?: string
  salesInvoiceSequence?: BaseSerialSequenceFragment
  operationDate?: string
  issueDate?: string
  dueDate?: string
  legalEntity?: LegalEntityForSelectFragment | null //issuer
  contact?: ContactFragment | null //receiver / recipient
  project?: FinancialProjectForSelectFragment | null
  subproject?: SubprojectForSelectFragment | null
  discountPercentage?: number | null
  lineItems: LineItem[] | []
  memo?: string
  footer?: string
  showMemo: boolean
  showFooter: boolean
  retentionTaxRate?: TaxRateForSelectFragment | null
  originalFinancialDocumentId?: number | null
  documentType: FinanceValueObjectsFinancialDocumentTypeEnum
  action: SaleInvoiceAction
  complianceExtraFields?: FormComplianceExtraFields | null
  salesDocumentTemplate?: SalesDocumentTemplateForSelectFragment | null
  logoFile?: File | null
  customComplianceExtraFieldErrors?: CustomComplianceExtraFieldErrors | null
  exchangeRate?: number | null
}

// {lineItems: {1: {fieldId: 'error message'}}}
// {documents: {fieldI: 'error message'}}
type DocumentComplianceExtraFieldError = Record<'document', Record<string, string>>
export type LineItemComplianceExtraFieldError = Record<
  'lineItems',
  {
    [index: string]: Record<string, string>
  }
>

export type CustomComplianceExtraFieldErrors = DocumentComplianceExtraFieldError &
  LineItemComplianceExtraFieldError

export interface LineItemWithComplianceExtraFieldsFormFields {
  lineItem: LineItem
  complianceExtraFields: FieldComplianceExtraField[]
}
